import React, { memo, useCallback } from 'react'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { ExportExcelButton, format2Print } from 'src/react-app/components/v2/export-excel-button'
import dayjs from 'dayjs'

export interface OrderPrintButtonProps {
  path: string
  columns: any[]
  stages: any[]
}

export const OrderPrintButton: React.FC<OrderPrintButtonProps> = memo(props => {
  const { path, columns, stages } = props

  const handlePrintClick = useCallback(async () => {
    try {
      const response = await fetchAPI(path)
      const data = response.data
      if (!data) {
        return
      }

      const viewColumnNames = columns.map(column => column.dataIndex)
      const count = data.length

      for (let i = 0; i < count; i++) {
        const keys = Object.keys(data[i])
        keys.forEach(key => {
          if (!viewColumnNames.includes(key)) {
            return
          }
          if (key === 'stage') {
            data[i][key] = stages.find(stage => stage.code === data[i][key])?.name || data[i][key]
            return
          }
          if (key === 'created_at') {
            data[i][key] = dayjs(data[i][key]).fromNow() || data[i][key]
            return
          }

          data[i][key] = format2Print(key, data[i][key])
        })
      }

      return data
    } catch (e) {
      console.error('handlePrintClick', e)
    }
  }, [columns, stages, path])

  return (
    <ExportExcelButton
      fileName={'Заказы'}
      path={path}
      columns={columns}
      onPrintClick={handlePrintClick}
    />
  )
})

OrderPrintButton.displayName = 'OrderPrintButton'
